<template>
  <input :placeholder="placeholder" v-model="inputValue" type="text" ref="input">
</template>

<script>
    export default {
        name: "autocomplete",
        props: ['placeholder', 'value', 'fields', 'restrictions'],
        data() {
            return {
                inputValue: '',
                googleAutocomplete: null
            }
        },
        computed: {
            inputElement() {
                return this.$refs['input'] ? this.$refs['input'] : null;
            },

            autocompleteFields() {
                if (this.fields) {
                    return this.fields;
                } else {
                    return [
                        'address_components',
                        'geometry',
                        'icon',
                        'name'
                    ]
                }
            },
            autocompleteOptions() {
                return {
                    componentRestrictions: {country: 'pl'}
                }
            }
        },
        watch: {
            inputValue(newVal) {
                this.$emit('input', newVal)
            },

            value(newVal) {
                this.inputValue = newVal;
            },

            restrictions() {
                if (this.googleAutocomplete) {
                    this.googleAutocomplete.setComponentRestrictions(this.restrictions);
                }

            }
        },
        mounted() {
            this.$googleApiPromise.then(google => {
                this.googleAutocomplete = new google.maps.places.Autocomplete(this.inputElement);
                this.googleAutocomplete.setFields(['geometry']);

                if (this.restrictions) {
                    this.googleAutocomplete.setComponentRestrictions(this.restrictions);
                }

                this.setAutocompleteFields(this.autocompleteFields);
                this.forwardEvents();
            })
        },
        methods: {
            setAutocompleteFields(fields) {
                this.googleAutocomplete.setFields(fields);
            },
            getSelectedPlace() {
                return this.googleAutocomplete.getPlace();
            },
            forwardEvents() {
                this.googleAutocomplete.addListener('place_changed', () => {
                    this.$emit('place_changed', this.getSelectedPlace())
                })
            }
        }
    }
</script>

<style scoped>

</style>
